import BarChart from "components/pages/dashboard/chart/BarChart";

const UserTransmissionProgressAnalyticChart = ({
  options,
  prepareChartData,
}) => {
  const chartData = prepareChartData();

  return (
    <BarChart
      options={options}
      data={chartData}
      height={300}
      style={{ cursor: "pointer" }}
    />
  );
};

export default UserTransmissionProgressAnalyticChart;
